import { ProtectedRouteContainer } from '@/components/ProtectedRouteContainer';
import { PageHeader } from '@/components/PageHeader';
import { ServiceCheck, FeatureAlert } from '@/shared/components';
import { ChecklistProvider } from './contexts/ChecklistContext';
import { useChecklistNew } from './useChecklistNew';
import { ChecklistDataSection } from './ChecklistDataSection';
import { ChecklistWorkspaceSection } from './ChecklistWorkspaceSection';
import { ActionButtons } from './shared/components';
import { Spin } from '@bancobarigui/barihaus';
import { useParams } from 'react-router-dom';

function ChecklistNewContent() {
  const {
    name,
    setName,
    selectedInspectionType,
    setSelectedInspectionType,
    inspectionTypes,
    loadingInspectionTypes,
    handleBack,
    handleSave,
    saving,
    loading,
  } = useChecklistNew();

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[400px]">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className="space-y-8">
      <ChecklistDataSection
        name={name}
        setName={setName}
        selectedInspectionType={selectedInspectionType}
        setSelectedInspectionType={setSelectedInspectionType}
        inspectionTypes={inspectionTypes}
        loadingInspectionTypes={loadingInspectionTypes}
      />

      <ChecklistWorkspaceSection />

      <ActionButtons
        onCancel={handleBack}
        onSave={handleSave}
        saveDisabled={saving}
        saveLoading={saving}
      />
    </div>
  );
}

export default function ChecklistNew() {
  const { id: checklistId } = useParams<{ id?: string }>();
  const isEditMode = !!checklistId;

  return (
    <ProtectedRouteContainer
      pageHeader={
        <PageHeader
          title={isEditMode ? 'Editar Checklist' : 'Novo Checklist'}
        />
      }
    >
      <FeatureAlert services={['checklist']} />
      <ServiceCheck
        services={['checklist']}
        featureName={isEditMode ? 'Edicao de Checklist' : 'Novo Checklist'}
      >
        <ChecklistProvider isEditMode={isEditMode}>
          <ChecklistNewContent />
        </ChecklistProvider>
      </ServiceCheck>
    </ProtectedRouteContainer>
  );
}
